/* Home-only state; the theme retains ownership of menus, search, account and cart. */
(() => {
  if (!document.body.classList.contains('nv-home-immersive')) return;
  const header = document.querySelector('#header-component');
  if (!header) return;
  let queued = false;
  const update = () => {
    header.dataset.nvScrolled = String(window.scrollY > 24);
    queued = false;
  };
  window.addEventListener('scroll', () => {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener('pageshow', update);
  update();
})();
